import { __assign, __extends } from "tslib";
import '../../../common/utils/polyfills';
import React from 'react';
import { viewModeWrapper, utils } from 'pro-gallery-lib';
import Gallery from './galleryContainer.js';
import { GalleryComponent } from '../../galleryComponent';
import '../../../versionLogger';
var ProGallery = /** @class */ (function (_super) {
    __extends(ProGallery, _super);
    function ProGallery(props) {
        var _this = _super.call(this) || this;
        _this.init(props);
        if (utils.isLocal() && !utils.isTest()) {
            console.log('PRO GALLERY DEV');
        }
        return _this;
    }
    ProGallery.prototype.init = function (props) {
        if (typeof props.viewMode !== 'undefined') {
            viewModeWrapper.setViewMode(props.viewMode);
        }
        if (typeof props.formFactor !== 'undefined') {
            viewModeWrapper.setFormFactor(props.formFactor);
        }
    };
    ProGallery.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (this.props.viewMode !== nextProps.viewMode) {
            utils.dumpCache();
            viewModeWrapper.setViewMode(nextProps.viewMode);
        }
        if (this.props.formFactor !== nextProps.formFactor) {
            utils.dumpCache();
            viewModeWrapper.setFormFactor(nextProps.formFactor);
        }
    };
    ProGallery.prototype.renderProps = function () {
        return __assign(__assign({}, this.props), { domId: this.props.domId, items: this.props.items || [], watermarkData: this.props.watermarkData, settings: this.props.settings || {}, offsetTop: this.props.offsetTop, itemsLoveData: this.props.itemsLoveData || {}, proGalleryRegionLabel: this.props.proGalleryRegionLabel ||
                'Gallery. you can navigate the gallery with keyboard arrow keys.' });
    };
    ProGallery.prototype.containerProps = function () {
        return {
            id: "pro-gallery-" + this.props.domId,
            className: 'pro-gallery',
        };
    };
    ProGallery.prototype.render = function () {
        return (React.createElement("div", __assign({}, this.containerProps()),
            React.createElement(Gallery, __assign({}, this.renderProps()))));
    };
    return ProGallery;
}(GalleryComponent));
export default ProGallery;
//# sourceMappingURL=proGallery.js.map